import React, { Component, PropTypes as T } from 'react';
import ReactDOM from 'react-dom';

import ScriptCache from './scriptCache';
import GoogleApi from './googleApi';
const defaultMapConfig = {}
const defaultCreateCache = (options) => {
    options = options || {};
    const apiKey = options.apiKey;
    const libraries = options.libraries || ['places'];

    return ScriptCache({
        google: GoogleApi({ apiKey: apiKey, libraries: libraries })
    });
};

export const wrapper = (options) => (WrappedComponent) => {
    const apiKey = options.apiKey;
    const libraries = options.libraries || ['places'];
    const createCache = options.createCache || defaultCreateCache;

    class Wrapper extends React.Component {
        static contextTypes = {
            refresh: React.PropTypes.func
        };

        constructor(props, context) {
            super(props, context);

            this.scriptCache = createCache(options);
            this.scriptCache.google.onLoad(this.onLoad.bind(this))

            this.state = {
                loaded: false,
                map: null,
                google: null
            }
        }

        onLoad(err, tag) {
            // TODO: finde better way to recompile the scriptCache
            
            if(!window.google) {
                window.location.reload();
            }
            this._gapi = window.google;
            this.setState({ loaded: true, google: this._gapi })
        }

        render() {
            const props = Object.assign({}, this.props, {
                loaded: this.state.loaded,
                google: window.google
            });

            return (
                <div>
                    <WrappedComponent {...props}/>
                </div>
            )
        }
    }

    return Wrapper;
}

export default wrapper;


// WEBPACK FOOTER //
// ./master/jsx/components/GoogleMap/utils/googleApiComponent.jsx